const isDigit = (char: string) => char >= '0' && char <= '9';

// Codes can be far wider than Number.MAX_SAFE_INTEGER, so the counter is a BigInt and the width
// comes from the entered code: "007" continues as "008", "099" widens to "100". A code that ends
// with no digits at all gets a counter appended instead: "BTL-SVR" continues as "BTL-SVR1".
export const buildSequentialCodes = (startCode: string, count: number): string[] | null => {
  const trimmed = startCode.trim();

  if (!trimmed || count < 1) return null;

  let digitsFrom = trimmed.length;
  while (digitsFrom > 0 && isDigit(trimmed[digitsFrom - 1])) digitsFrom--;

  const prefix = trimmed.slice(0, digitsFrom);
  const digits = digitsFrom < trimmed.length ? trimmed.slice(digitsFrom) : '1';
  const start = BigInt(digits);

  return Array.from({ length: count }, (_, index) => `${prefix}${(start + BigInt(index)).toString().padStart(digits.length, '0')}`);
};
